import { loadScript } from '~utils/loadScript';

export type CodeResponse = { code?: string; error?: string };
export type CodeClientError = { type: 'popup_closed' | 'popup_failed_to_open' | 'unknown' };

type GoogleIdGlobal = {
  accounts: {
    oauth2: {
      initCodeClient(config: {
        client_id: string;
        scope: string;
        ux_mode: 'popup';
        callback: (response: CodeResponse) => void;
        error_callback?: (error: CodeClientError) => void;
      }): { requestCode(): void };
    };
  };
};

declare global {
  interface Window {
    google?: GoogleIdGlobal;
  }
}

export const loadGoogleSdk = async (): Promise<GoogleIdGlobal> => {
  await loadScript('https://accounts.google.com/gsi/client');
  if (!window.google) throw new Error('Google Identity SDK unavailable');
  return window.google;
};
